{
  "configurationModal": {
    "title": "Create New Home Page Configuration",
    "name": "Configuration Name"
  },
  "editHomePageModal": {
    "title": "Edit Home Page",
    "name": "Page Name",
    "save": "Save"
  },
  "editor": {
    "description": "Configure widgets and content for this home page layout.",
    "saveChanges": "Save Changes",
    "delete": "Delete Configuration",
    "addWidget": "Add Widget",
    "edit": "Edit",
    "deleteConfirmation": "Are you sure you want to delete this home page configuration? This action cannot be undone."
  },
  "widget": {
    "addWidget": "Add Home Page Widget",
    "editWidget": "Edit Widget",
    "options": "Widget Options",
    "noWidgets": "No widgets configured. Add a widget to get started.",
    "freeFormInput": {
      "title": "Free Form Content",
      "description": "Add custom content, text, and media to your home page"
    }
  },
  "practiceOverview": {
    "totalAum": "Total AUM",
    "averageAum": "Average AUM/Client",
    "totalClients": "Total Clients",
    "netflows": "Netflows",
    "managementFees": "Management Fees",
    "fundedClients": "Funded Clients",
    "cashPercentage": "Cash Percentage",
    "fromLastMonth": "from last month"
  },
  "welcome": "Welcome",
  "other": "Other",
  "aumExplorer": {
    "accountType": "Account Type",
    "modelPortfolio": "Model Portfolio",
    "childOrganization": "Child Organization",
    "repCode": "Rep Code",
    "noData": "No data available"
  },
  "feesAndRevenue": {
    "noFeesCollectedYet": "No fees collected yet",
    "timeFrame": {
      "1Y": "1Y",
      "YTD": "YTD"
    }
  },
  "report": {
    "filter": {
      "any": "Any",
      "individual": "Individual",
      "nonIndividual": "Non-individual"
    }
  },
  "productAumExposure": {
    "security": "Security",
    "selectSecurity": "Select a security to view exposure rankings.",
    "noResults": "No clients hold this security.",
    "summary": "The total exposure to {{productName}} ({{ticker}}) is {{totalMarketValue}}. This exposure is spread across {{count}} {{levelLabel}}. Below is the ranked list by exposure:",
    "exposureLevels": {
      "HOUSEHOLD_one": "household",
      "HOUSEHOLD_other": "households",
      "ENTITY_one": "entity",
      "ENTITY_other": "entities",
      "ACCOUNT_one": "account",
      "ACCOUNT_other": "accounts"
    },
    "exportFileName": "Product_AUM_Exposure",
    "exportProgressTitle": "Exporting product AUM exposure",
    "columns": {
      "rank": "Rank",
      "householdName": "Household",
      "entityName": "Entity",
      "firstName": "First Name",
      "lastName": "Last Name",
      "accountName": "Account",
      "accountType": "Account Type",
      "accountNumber": "Account Number",
      "marketValue": "Market Value"
    }
  }
}
